export default "/images/vendor/@coreui/icons/svg/flag/cif-cf.svg?99fbabfddb392968f4a35dcf2a65e500";